/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IndustryExpertiseWithLabel
 */
export interface IndustryExpertiseWithLabel {
    /**
     * 
     * @type {string}
     * @memberof IndustryExpertiseWithLabel
     */
    businessSectorHumanId: string;
    /**
     * 
     * @type {string}
     * @memberof IndustryExpertiseWithLabel
     */
    businessIndustryHumanId: string;
    /**
     * 
     * @type {string}
     * @memberof IndustryExpertiseWithLabel
     */
    label: string;
}

/**
 * Check if a given object implements the IndustryExpertiseWithLabel interface.
 */
export function instanceOfIndustryExpertiseWithLabel(value: object): value is IndustryExpertiseWithLabel {
    if (!('businessSectorHumanId' in value) || value['businessSectorHumanId'] === undefined) return false;
    if (!('businessIndustryHumanId' in value) || value['businessIndustryHumanId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function IndustryExpertiseWithLabelFromJSON(json: any): IndustryExpertiseWithLabel {
    return IndustryExpertiseWithLabelFromJSONTyped(json, false);
}

export function IndustryExpertiseWithLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndustryExpertiseWithLabel {
    if (json == null) {
        return json;
    }
    return {
        
        'businessSectorHumanId': json['businessSectorHumanId'],
        'businessIndustryHumanId': json['businessIndustryHumanId'],
        'label': json['label'],
    };
}

export function IndustryExpertiseWithLabelToJSON(value?: IndustryExpertiseWithLabel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'businessSectorHumanId': value['businessSectorHumanId'],
        'businessIndustryHumanId': value['businessIndustryHumanId'],
        'label': value['label'],
    };
}

